// tanstack
import { useParams } from '@tanstack/react-router';

// relative
import { useGetAccountByIdQuery } from '../api/recalc/endpoints/accountsApiSlice';

interface UseHasServiceResult {
  hasService: boolean;
  account: ReturnType<typeof useGetAccountByIdQuery>['data'];
  isLoading: boolean;
  error: ReturnType<typeof useGetAccountByIdQuery>['error'];
}

/**
 * Custom hook to check if an account has a specific service.
 */
export const useHasService = (serviceName: string): UseHasServiceResult => {
  const { accountId } = useParams({ strict: false });

  const {
    data: account,
    isLoading,
    error,
  } = useGetAccountByIdQuery(accountId, {
    skip: !accountId,
  });

  const hasService =
    account?.Services?.some(
      (service: { Name: string }) => service.Name === serviceName,
    ) ?? false;

  return {
    hasService,
    account,
    isLoading,
    error,
  };
};
